import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { Skeleton } from '@/new/components/shadcn/skeleton';

export function MatterOverviewLoader() {
  return (
    <>
      <Breadcrumb items={[{ href: '/matters', label: 'Matters', active: false }]} />

      <PageContainer>
        <PageHeader>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-5 w-48" />
          </div>

          <div className="flex items-center gap-2">
            <Skeleton className="h-9 w-24" />
            <Skeleton className="h-9 w-32" />
          </div>
        </PageHeader>

        <div className="mb-6 grid grid-cols-1 gap-3 lg:grid-cols-5">
          <div className="grid grid-cols-4 gap-3 lg:col-span-3">
            <Skeleton className="h-20 rounded-md" />
            <Skeleton className="h-20 rounded-md" />
            <Skeleton className="h-20 rounded-md" />
            <Skeleton className="h-20 rounded-md" />
          </div>

          <Skeleton className="h-20 rounded-md lg:col-span-2" />
        </div>

        <div className="mb-2 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-6">
              <div className="mb-3 flex items-center justify-between">
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-4 w-16" />
              </div>
              <div className="flex flex-col gap-2">
                <Skeleton className="h-16 rounded-md" />
                <Skeleton className="h-16 rounded-md" />
                <Skeleton className="h-16 rounded-md" />
              </div>
            </div>
            <Skeleton className="h-32 rounded-md" />
          </div>

          <div className="lg:col-span-1">
            <div className="mb-6">
              <Skeleton className="mb-2 h-6 w-24" />
              <Skeleton className="h-20 rounded-md" />
            </div>
            <Skeleton className="h-32 rounded-md" />
          </div>
        </div>
      </PageContainer>
    </>
  );
}
